import React from 'react';
import {injectIntl} from 'react-intl';
import {Redirect} from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';

import API from '../../common/utils/API';
import {formatErrorMessageFromAPI} from '../../common/utils/helpers';
import Form from '../../components/form/cities/CityForm';

export class CreateCity extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            states: [],

            // Redirects
            shouldRedirectToIndex: false,

            // Errors
            errorMessage: '',

            // Loading
            loading: false,
        };
    }

    async componentDidMount() {
        await this.fetchStates();
    }

    fetchStates = async () => {
        this.setState({loading: true});

        try {
            const {states} = await API.states.getAll();

            this.setState({
                states,
                loading: false,
            });
        } catch (e) {
            this.setState({
                errorMessage: this.props.intl.formatMessage({
                    id: 'ERROR_PAGES.LOADING_DATA',
                }),
                loading: false,
            });
        }
    };

    onSubmit = async (input) => {
        this.setState({loading: true});

        try {
            await API.cities.save(input);

            this.setState({loading: false, shouldRedirectToIndex: true});
        } catch (e) {
            const error = formatErrorMessageFromAPI(
                e,
                this.props.intl.formatMessage({
                    id: 'ERROR_PAGES.STORING_DATA',
                }),
            );

            this.setState({
                ...error,
            });
        }
    };

    render() {
        const {shouldRedirectToIndex} = this.state;
        const states = this.state.states.map((state) => ({
            value: state.id,
            label: state.name,
        }));
        const initialValues = {
            name: '',
            state: '',
            code: '',
            timeZone: '',
        };

        return shouldRedirectToIndex ? (
            <Redirect
                data-test='redirectToIndex'
                to={{
                    pathname: '/cities',
                    state: {
                        successMessage: this.props.intl.formatMessage({
                            id: 'CITIES.CITY_SUCCESSFULLY_CREATED_MESSAGE',
                        }),
                    },
                }}
            />
        ) : (
            <>
                <Alert
                    variant='danger'
                    className='mb-4'
                    show={!!this.state.errorMessage}
                >
                    <p className='mb-0'>{this.state.errorMessage}</p>
                </Alert>
                <Form
                    data-test='createCityComponent'
                    initialValues={initialValues}
                    backRedirectUrl='/cities'
                    backText={this.props.intl.formatMessage({
                        id: 'LIST.BACK_TO_LIST',
                    })}
                    states={states}
                    loading={this.state.loading}
                    handleSubmit={this.onSubmit}
                />
            </>
        );
    }
}

export default injectIntl(CreateCity);
